export default {
  title: 'Nebula buds AI Arama', // "Nebula buds AI通话" 翻译为土耳其语
  userID: 'Kullanıcı ID : ', // "用户ID : "
  hurryUp: 'Karşı taraftan arama bekleniyor', // "等待对方呼叫"
  waitingCall: 'Karşı taraftan arama bekleniyor, lütfen sayfayı erken kapatmayın.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Altyazı Anahtarı', // "字幕开关"
  initWait: 'Başlatılmayı bekliyor', // "等待初始化"
  initSuccess: 'Başlatma tamamlandı, karşı taraftan arama bekliyor. Lütfen sayfayı kapatmayın!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Arama Bağlantısı Kuruldu', // "电话接通"
  callEnd: 'Arama Sonlandırıldı', // "通话结束"
  careful: 'Dikkat : ', // "注意 : "
  wait: 'Arama bileşeni hazır, karşı taraftan arama bekleniyor', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arapça', // "阿拉伯语"
    da: 'Danca', // "丹麦语"
    de: 'Almanca', // "德语"
    en: 'İngilizce', // "英语"
    es: 'İspanyolca', // "西班牙语"
    fil: 'Filipince', // "菲律宾语"
    fr: 'Fransızca', // "法语"
    hi: 'Hindistan Dili', // "印地语"
    id: 'Endonezyaca', // "印度尼西亚语"
    it: 'İtalyanca', // "意大利语"
    ja: 'Japonca', // "日文"
    ko: 'Korece', // "韩语"
    ms: 'Malayca', // "马来语"
    no: 'Norveççe', // "挪威语"
    pt: 'Portekizce', // "葡萄牙语"
    ru: 'Rusça', // "俄语"
    sv: 'İsveççe', // "瑞典语"
    th: 'Tayca', // "泰语"
    tr: 'Türkçe', // "土耳其语"
    vi: 'Vietnamca', // "越南语"
    zh: 'Çince' // "中文"
  }
}
